import { isAxiosError } from 'axios'
import { isLikelyNetworkError } from '~shared/errors/sentryNoise'

export const CREATE_EVENT_WIZARD_LOAD_ERROR_MESSAGE =
    'Vi kunne ikke hente data til arrangementsflowet. Tjek din internetforbindelse og prøv igen.'

export function isAxiosNetworkError(error: unknown): boolean {
    return isLikelyNetworkError(error)
}

/** Backend SimpleErrorResponse `{ error: "..." }` or similar envelopes. */
export function getAxiosErrorMessage(error: unknown): string | null {
    if (!isAxiosError(error)) {
        return null
    }

    const data = error.response?.data
    if (data && typeof data === 'object') {
        const record = data as Record<string, unknown>
        if (typeof record.error === 'string' && record.error.trim()) {
            return record.error.trim()
        }
        if (typeof record.message === 'string' && record.message.trim()) {
            return record.message.trim()
        }
    }

    if (typeof data === 'string' && data.trim()) {
        return data.trim()
    }

    return null
}

export function getUserFacingErrorMessage(error: unknown): string {
    const apiMessage = getAxiosErrorMessage(error)
    if (apiMessage) {
        return apiMessage.replace(/^❌\s*Valideringsfejl:\s*/i, '')
    }

    return error instanceof Error ? error.message : String(error)
}

export function isUserValidationError(error: unknown): boolean {
    const message = error instanceof Error ? error.message : String(error)
    if (message.includes('Valideringsfejl') || message.includes('VALIDATION FAILED')) {
        return true
    }

    if (isAxiosError(error) && error.response?.status === 400 && getAxiosErrorMessage(error)) {
        return true
    }

    return false
}

export function formatAxiosErrorDetails(error: unknown): string {
    if (!isAxiosError(error)) {
        return error instanceof Error ? error.message : String(error)
    }

    const baseURL = error.config?.baseURL ?? ''
    const url = error.config?.url ?? ''
    const fullUrl = url.startsWith('http') ? url : `${baseURL}${url}`
    const method = (error.config?.method ?? 'get').toUpperCase()
    const status = error.response?.status
    const code = error.code ? ` (${error.code})` : ''

    if (status) {
        return `${method} ${fullUrl} — HTTP ${status}${code}`
    }

    return `${method} ${fullUrl} — ${error.message}${code}`
}
